import { useTranslation } from 'react-i18next';

/**
 * A custom React hook that returns an array of pronunciation options.
 *
 * @returns An array of objects, each representing a pronunciation option with a label and value.
 */
export const usePronunciationOptions = () => {
  const { t } = useTranslation();

  return [
    { label: t('male'), value: 'Male' },
    { label: t('female'), value: 'Female' },
  ];
};
